/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/components';

export default (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <Path d="M18 2l2 4h-2l-2-4h-3l2 4h-2l-2-4h-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2zm2 12H10V4.4L11.8 8H20z" />
        <Path d="M14 20H4V10h3V8H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2z" />
        <Path d="M5 19h8l-1.59-2H9.24l-.84 1.1L7 16.3 5 19z" />
    </SVG>
);